export default "__VITE_ASSET__dHGOEupg__"